import React from "react";
import styled from "styled-components";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.bealyo.bealyoapp";

//const APP_STORE_URL = "PASTE_YOUR_APP_STORE_URL_HERE";
const APP_STORE_URL = "https://apps.apple.com/app/id6773874077";

const PageContainer = styled.div`
  min-height: 100vh;
  padding: 0px 20px 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #e5e7eb;
  background:
    radial-gradient(circle at top, rgba(56, 189, 248, 0.25), transparent 60%),
    radial-gradient(
      circle at bottom,
      rgba(236, 72, 153, 0.18),
      transparent 55%
    ),
    #020617;
  background-attachment: fixed;
`;

const LogoWrap = styled.div`
  margin-bottom: 22px;

  img {
    height: 58px;
    width: auto;
    display: block;
    object-fit: contain;
  }

  @media (max-width: 600px) {
    img {
      height: 48px;
    }
  }
`;

const SectionTitle = styled.section`
  max-width: 760px;
  text-align: center;
  margin: 28px auto 22px;

  h2 {
    font-size: 34px;
    font-weight: 800;
    margin-bottom: 10px;
  }

  p {
    color: rgba(226, 232, 240, 0.78);
    font-size: 17px;
    line-height: 1.6;
  }
`;

const FeatureGrid = styled.section`
  max-width: 1100px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
  margin: 0 auto 44px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureBox = styled.div`
  background: linear-gradient(
    180deg,
    rgba(15, 23, 42, 0.95),
    rgba(15, 23, 42, 0.74)
  );
  border: 1px solid rgba(148, 163, 184, 0.36);
  border-radius: 22px;
  padding: 22px;
  min-height: 190px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.35);

  div {
    font-size: 30px;
    margin-bottom: 12px;
  }

  h3 {
    font-size: 19px;
    margin-bottom: 8px;
  }

  p {
    color: rgba(226, 232, 240, 0.78);
    line-height: 1.55;
    font-size: 14px;
  }
`;

const Hero = styled.section`
  max-width: 1100px;
  width: 100%;
  margin: 40px auto 50px;
  display: flex;
  align-items: center;
  gap: 48px;
  flex-wrap: wrap;
`;

const HeroLeft = styled.div`
  flex: 1 1 320px;
`;

const HeroRight = styled.div`
  flex: 1 1 260px;
  display: flex;
  justify-content: center;
`;

const Pill = styled.div`
  display: inline-block;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.9);
  border: 1px solid rgba(148, 163, 184, 0.6);
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 16px;
  color: #e5e7eb;
`;

const FinalCTA = styled.section`
  max-width: 760px;
  width: 100%;
  text-align: center;
  margin: 20px auto 42px;
  padding: 34px 28px;
  border-radius: 28px;
  background:
    radial-gradient(
      circle at top left,
      rgba(249, 115, 22, 0.28),
      transparent 50%
    ),
    radial-gradient(
      circle at bottom right,
      rgba(236, 72, 153, 0.28),
      transparent 50%
    ),
    rgba(15, 23, 42, 0.92);
  border: 1px solid rgba(248, 113, 113, 0.35);
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.55);

  h2 {
    font-size: 34px;
    font-weight: 800;
    margin-bottom: 10px;
  }

  p {
    color: rgba(226, 232, 240, 0.86);
    font-size: 17px;
    line-height: 1.65;
    margin-bottom: 24px;
  }
`;

const Title = styled.h1`
  font-size: 56px;
  font-weight: 800;
  margin-bottom: 18px;
  text-shadow: 0 8px 24px rgba(0, 0, 0, 0.7);

  @media (max-width: 600px) {
    font-size: 40px;
  }
`;

const Subtitle = styled.p`
  font-size: 18px;
  color: rgba(226, 232, 240, 0.85);
  max-width: 620px;
  margin: 0 0 28px;
  line-height: 1.6;

  @media (max-width: 600px) {
    font-size: 16px;
  }
`;

const StepsCard = styled.div`
  background:
    radial-gradient(
      circle at top left,
      rgba(56, 189, 248, 0.22),
      transparent 60%
    ),
    radial-gradient(
      circle at bottom right,
      rgba(168, 85, 247, 0.25),
      transparent 55%
    ),
    rgba(15, 23, 42, 0.96);
  backdrop-filter: blur(18px);
  border-radius: 24px;
  padding: 26px 26px 22px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.75);
  max-width: 420px;
`;

const DownloadTitle = styled.h2`
  font-size: 24px;
  margin-bottom: 16px;
  text-align: left;
`;

const Steps = styled.ol`
  list-style: none;
  padding: 0;
  margin: 0 0 22px;

  li {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 6px 0;
    font-size: 15px;
    color: rgba(226, 232, 240, 0.92);
  }
`;

const StepNumber = styled.span`
  width: 26px;
  height: 26px;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
`;

const DownloadButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 46px;
  text-decoration: none;
  transition:
    transform 0.15s ease,
    opacity 0.15s ease;

  &:hover {
    transform: translateY(-2px);
    opacity: 0.92;
    text-decoration: none;
  }

  img {
    height: 54px;
    width: auto;
    display: block;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  margin-top: 24px;
`;

const SmallNote = styled.p`
  margin-top: 12px;
  font-size: 13px;
  color: rgba(148, 163, 184, 0.88);
  line-height: 1.5;
`;

/* ---- PHONE + CAROUSEL ---- */

const PhoneCarousel = styled.div`
  position: relative;
  width: 260px;
  height: 520px;

  @media (max-width: 600px) {
    width: 240px;
    height: 480px;
  }
`;

const PhoneMock = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 38px;
  padding: 14px;
  background: linear-gradient(145deg, #111827, #020617);
  border: 1px solid rgba(148, 163, 184, 0.7);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.9);
`;

const PhoneScreen = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 28px;
  padding: 18px 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #e5e7eb;
  font-size: 13px;
  background: ${(props) => {
    if (props.variant === "gps") {
      return "radial-gradient(circle at top, #3b82f6, #0f172a 45%, #020617 100%)";
    }
    if (props.variant === "community") {
      return "radial-gradient(circle at top, #a855f7, #0f172a 45%, #020617 100%)";
    }
    return "radial-gradient(circle at top, #22c55e, #0f172a 45%, #020617 100%)";
  }};
`;

const PhoneHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
`;

const PhoneChip = styled.div`
  padding: 4px 9px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.8);
  font-size: 11px;
`;

const PhoneCard = styled.div`
  background: rgba(15, 23, 42, 0.9);
  border-radius: 16px;
  padding: 10px 12px;
  margin-bottom: 8px;
  border: 1px solid rgba(148, 163, 184, 0.35);
`;

const PhoneFooter = styled.div`
  font-size: 11px;
  opacity: 0.8;
  text-align: center;
`;

/* Carousel controls */

const NavButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: rgba(15, 23, 42, 0.95);
  width: 30px;
  height: 30px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e5e7eb;
  cursor: pointer;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.7);
  font-size: 16px;
  padding: 0;

  &:hover {
    background: rgba(30, 64, 175, 0.98);
  }

  &:disabled {
    opacity: 0.35;
    cursor: default;
  }
`;

const NavPrev = styled(NavButton)`
  left: -18px;

  @media (max-width: 600px) {
    left: -6px;
  }
`;

const NavNext = styled(NavButton)`
  right: -18px;

  @media (max-width: 600px) {
    right: -6px;
  }
`;

const Dots = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-top: 14px;
`;

const StatsRow = styled.section`
  max-width: 1100px;
  width: 100%;
  margin: -20px auto 36px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const StatCard = styled.div`
  background: rgba(15, 23, 42, 0.82);
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 18px;
  padding: 16px;
  backdrop-filter: blur(14px);

  strong {
    display: block;
    font-size: 18px;
    margin-bottom: 5px;
  }

  span {
    color: rgba(226, 232, 240, 0.78);
    font-size: 13px;
    line-height: 1.45;
  }
`;

const Dot = styled.button`
  width: ${(props) => (props.active ? "14px" : "8px")};
  height: 8px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  background: ${(props) =>
    props.active ? "#f97316" : "rgba(148, 163, 184, 0.7)"};
  opacity: ${(props) => (props.active ? 1 : 0.6)};
  padding: 0;
`;

/* ---- REST OF THE PAGE ---- */

const WhyRow = styled.section`
  max-width: 1100px;
  width: 100%;
  margin: 0 auto 40px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const WhyCard = styled.div`
  background: rgba(15, 23, 42, 0.95);
  border-radius: 18px;
  padding: 18px 20px;
  border: 1px solid rgba(148, 163, 184, 0.45);

  h3 {
    font-size: 17px;
    margin-bottom: 6px;
  }

  p {
    font-size: 14px;
    color: rgba(209, 213, 219, 0.9);
    line-height: 1.55;
  }
`;

const Features = styled.section`
  max-width: 900px;
  width: 100%;
  margin: 10px auto 36px;
  text-align: center;

  h3 {
    font-size: 22px;
    margin-bottom: 14px;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  li {
    margin: 6px 0;
    font-size: 16px;
    color: rgba(226, 232, 240, 0.9);
  }
`;

const Feedback = styled.section`
  max-width: 600px;
  width: 100%;
  margin: 0 auto 10px;
  text-align: center;

  h4 {
    font-size: 18px;
    margin-bottom: 10px;
  }
  p {
    color: rgba(148, 163, 184, 0.9);
    font-size: 14px;
  }
`;

/* ---- PHONE SCREEN DATA ---- */

const phoneScreensOld = [
  {
    id: "daily",
    variant: "daily",
    header: "Today • 5.2 km",
    chip: "Streak x4 🔥",
    footer: "Track your activities, habits and wins in one place.",
    body: () => (
      <div style={{ marginTop: 12 }}>
        <PhoneCard>
          <strong>Morning Run</strong>
          <div>Park • 32 min • 4.1 km</div>
        </PhoneCard>
        <PhoneCard>
          <strong>Cold Shower Legend</strong>
          <div>Task completed • +15 XP</div>
        </PhoneCard>
        <PhoneCard>
          <strong>Hydration Hero</strong>
          <div>8/8 cups logged</div>
        </PhoneCard>
      </div>
    ),
  },
  {
    id: "gps",
    variant: "gps",
    header: "Saturday Run • 7.8 km",
    chip: "Route complete ✅",
    footer: "See every km, pace and route with live GPS tracking.",
    body: () => (
      <div style={{ marginTop: 12 }}>
        <PhoneCard style={{ marginBottom: 10 }}>
          <strong>City Loop Route</strong>
          <div>7.8 km • 5:42 /km • 44 min</div>
        </PhoneCard>
        <PhoneCard>
          <div style={{ fontSize: 11, opacity: 0.9 }}>
            Split times, pace zones and elevation — all in one clean view.
          </div>
        </PhoneCard>
      </div>
    ),
  },
  {
    id: "community",
    variant: "community",
    header: "Circle • Morning Legends",
    chip: "8 friends active now",
    footer: "Stay accountable with circles, cheers and shared wins.",
    body: () => (
      <div style={{ marginTop: 12 }}>
        <PhoneCard>
          <strong>Noa just crushed “5K & Proud”</strong>
          <div>🔥🔥🔥 • 17 cheers</div>
        </PhoneCard>
        <PhoneCard>
          <strong>You</strong>
          <div>Cold Shower Legend • Day 4 / 7</div>
        </PhoneCard>
        <PhoneCard>
          <div>“Let’s hit 10k steps together today 💪”</div>
        </PhoneCard>
      </div>
    ),
  },
];

const phoneScreens = [
  {
    id: "daily",
    variant: "daily",
    header: "Daily wins & streaks",
    footer: "Track your activities, habits and wins in one place.",
    image: "/earlyaccess/home1dark@2x.png",
  },
  {
    id: "gps",
    variant: "gps",
    header: "GPS running & walking",
    footer: "See every km, pace and route with live GPS tracking.",
    image: "/earlyaccess/home2dark@2x.png",
  },
  {
    id: "community",
    variant: "community",
    header: "Circles & community",
    footer: "Stay accountable with circles, cheers and shared wins.",
    image: "/earlyaccess/home4dark@2x.png",
  },
];

const PhoneImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 28px;
  object-fit: cover;
  display: block;
`;

const EarlyAccess = () => {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const active = phoneScreens[activeIndex];

  const goPrev = () => {
    setActiveIndex((prev) => (prev === 0 ? phoneScreens.length - 1 : prev - 1));
  };

  const goNext = () => {
    setActiveIndex((prev) => (prev === phoneScreens.length - 1 ? 0 : prev + 1));
  };

  return (
    <PageContainer>
      <Hero>
        <HeroLeft>
          <LogoWrap>
            <img src="/logo.png" alt="Bealyo" />
          </LogoWrap>

          <Pill>Now available on iPhone & Android</Pill>
          <Title>Be the Best Version of Yourself</Title>

          <Subtitle>
            Bealyo helps you turn good intentions into real daily progress.
            Build better habits, complete meaningful challenges, stay active,
            track your health, and grow with a positive community that cheers
            you forward.
            <br />
            <br />
            Start small. Stay consistent. Become the person you know you can be.
          </Subtitle>

          <StepsCard>
            <DownloadTitle>Start Your Journey Today</DownloadTitle>

            <Steps>
              <li>
                <StepNumber>1</StepNumber>Download Bealyo on iPhone or Android
              </li>
              <li>
                <StepNumber>2</StepNumber>Create your free account
              </li>
              <li>
                <StepNumber>3</StepNumber>Choose goals, challenges, or habits
                that matter to you
              </li>
              <li>
                <StepNumber>4</StepNumber>Take small daily steps toward your
                best self
              </li>
            </Steps>

            <ButtonRow>
              <DownloadButton
                href={APP_STORE_URL}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="/store-badges/app-store-badge.svg"
                  alt="Download on the App Store"
                />
              </DownloadButton>

              <DownloadButton
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="/store-badges/google-play-badge.png"
                  alt="Get it on Google Play"
                />
              </DownloadButton>
            </ButtonRow>

            <SmallNote>
              Bealyo is live now. Your next step starts today.
            </SmallNote>
          </StepsCard>
        </HeroLeft>

        <HeroRight>
          <div>
            <PhoneCarousel>
              <PhoneMock>
                <PhoneImage src={active.image} alt={active.header} />
                {/**
                <PhoneScreen variant={active.variant}>
                  <div>
                    <PhoneHeader>
                      <span>{active.header}</span>
                      <PhoneChip>{active.chip}</PhoneChip>
                    </PhoneHeader>
                    {active.body()}
                  </div>
                  <PhoneFooter>{active.footer}</PhoneFooter>
                </PhoneScreen>
                */}
              </PhoneMock>

              <NavPrev onClick={goPrev} aria-label="Previous screen">
                ‹
              </NavPrev>
              <NavNext onClick={goNext} aria-label="Next screen">
                ›
              </NavNext>
            </PhoneCarousel>

            <Dots>
              {phoneScreens.map((screen, i) => (
                <Dot
                  key={screen.id}
                  active={i === activeIndex}
                  onClick={() => setActiveIndex(i)}
                  aria-label={`Show ${screen.id} preview`}
                />
              ))}
            </Dots>
          </div>
        </HeroRight>
      </Hero>

      <StatsRow>
        <StatCard>
          <strong>Goals</strong>
          <span>Create challenges, habits, and routines</span>
        </StatCard>
        <StatCard>
          <strong>GPS</strong>
          <span>Track walks, runs, distance, and pace</span>
        </StatCard>
        <StatCard>
          <strong>Nutrition</strong>
          <span>Log meals, calories, and daily health</span>
        </StatCard>
        <StatCard>
          <strong>Community</strong>
          <span>Join circles and grow with others</span>
        </StatCard>
      </StatsRow>

      <SectionTitle>
        <h2>One App for Your Personal Growth</h2>
        <p>
          Bealyo brings goals, health, activity tracking, routines, and
          community into one experience designed to help you keep moving.
        </p>
      </SectionTitle>

      <FeatureGrid>
        {[
          [
            "🎯",
            "Goals & Challenges",
            "Create personal goals, join challenges, and follow clear daily actions.",
          ],
          [
            "🏃",
            "GPS Activity Tracking",
            "Track walks and runs with distance, pace, time, and route history.",
          ],
          [
            "🥗",
            "Nutrition & Meals",
            "Manage meals, calories, hydration, and healthier daily choices.",
          ],
          [
            "✅",
            "Daily Tasks",
            "Break big goals into small actions you can complete every day.",
          ],
          [
            "🔥",
            "Streaks & Badges",
            "Stay motivated with progress, streaks, XP, and achievements.",
          ],
          [
            "👥",
            "Circles",
            "Join positive groups where people support, cheer, and grow together.",
          ],
        ].map(([icon, title, text]) => (
          <FeatureBox key={title}>
            <div>{icon}</div>
            <h3>{title}</h3>
            <p>{text}</p>
          </FeatureBox>
        ))}
      </FeatureGrid>

      <WhyRow>
        <WhyCard>
          <h3>Build Momentum</h3>
          <p>
            Turn goals into daily action through habits, challenges, routines,
            and small wins that keep you moving forward.
          </p>
        </WhyCard>

        <WhyCard>
          <h3>See Your Progress</h3>
          <p>
            Track workouts, runs, walks, nutrition, daily tasks, and personal
            achievements so every effort counts.
          </p>
        </WhyCard>

        <WhyCard>
          <h3>Grow Together</h3>
          <p>
            Join a positive community where people encourage each other,
            celebrate progress, and stay accountable.
          </p>
        </WhyCard>
      </WhyRow>

      <FinalCTA>
        <h2>Your Future Self Will Thank You</h2>
        <p>
          Don’t wait for the perfect Monday. Start with one small action today.
          Bealyo helps you build the habits, routines, and mindset that move you
          closer to the person you want to become.
        </p>

        <ButtonRow>
          <DownloadButton href={APP_STORE_URL} target="_blank" rel="noreferrer">
            <img
              src="/store-badges/app-store-badge.svg"
              alt="Download on the App Store"
            />
          </DownloadButton>

          <DownloadButton
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="/store-badges/google-play-badge.png"
              alt="Get it on Google Play"
            />
          </DownloadButton>
        </ButtonRow>
      </FinalCTA>

      <Feedback>
        <h4>Feedback</h4>
        <p>
          Found a bug or have an idea?
          <br />
          We'd love to hear from you.
          <br />
          📩{" "}
          <a href="mailto:support@bealyo.com" style={{ color: "#e5e7eb" }}>
            support@bealyo.com
          </a>
        </p>

        <div
          style={{
            marginTop: 14,
            display: "flex",
            justifyContent: "center",
            gap: 18,
          }}
        >
          <a
            href="https://instagram.com/bealyoversion"
            target="_blank"
            rel="noreferrer"
            title="Instagram"
            style={{ color: "#e5e7eb", fontSize: 22 }}
          >
            📸
          </a>

          <a
            href="https://x.com/bealyoversion"
            target="_blank"
            rel="noreferrer"
            title="X (Twitter)"
            style={{ color: "#e5e7eb", fontSize: 22 }}
          >
            🐦‍⬛
          </a>
        </div>
      </Feedback>
    </PageContainer>
  );
};

export default EarlyAccess;
